<template>
  <div class="visit-notes_card_encounter-notes">
    <VisitNotesCardHeader id="other" :title="$t('visits.summary.encounterNotes')" @clear="clearEncounterNoteFields" />
    <v-row no-gutters class="align-center">
      <v-col cols="4" class="mb-5">{{ $t("visits.chiefComplaint") }}</v-col
      ><v-col
        ><Select
          v-model="encounterNotes.chiefComplaint"
          :label="$t('practitioner.appointments.selectComplaint')"
          :items="chiefComplaints"
          fieldName="chiefComplaint"
          @change="onChange" /></v-col
    ></v-row>
    <v-row no-gutters class="align-center">
      <v-col cols="4" class="mb-5">{{ $t("visits.notes.dx") }}</v-col
      ><v-col
        ><BaseInput
          v-model="encounterNotes.dx"
          :placeholder="$t('visits.notes.enterAbbreviation')"
          fieldName="dx"
          @change="onChange" /></v-col
    ></v-row>
    <Textarea
      :placeholder="$t('visits.notes.assessment')"
      v-model="encounterNotes.assessment"
      fieldName="assessment"
      @change="onChange"
    />
    <Textarea
      :placeholder="$t('visits.notes.plan')"
      v-model="encounterNotes.plan"
      fieldName="plan"
      @change="onChange"
    />
    <Textarea
      :placeholder="$t('visits.notes.followUpNote')"
      v-model="encounterNotes.followUp"
      fieldName="followUp"
      @change="onChange"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

import BaseInput from "@/components/uikit/BaseInput";
import Select from "@/components/uikit/Select";
import Textarea from "@/components/uikit/Textarea";

import VisitNotesCardHeader from "./CardHeader.vue";

export default {
  name: "EncounterNotes",
  components: {
    VisitNotesCardHeader,
    BaseInput,
    Select,
    Textarea,
  },
  computed: {
    ...mapGetters("visitNote", ["encounterNotes"]),
    chiefComplaints() {
      const chiefComplaints = this.$t("general.chiefComplaints");
      if (!chiefComplaints) {
        return [];
      }
      return Object.keys(chiefComplaints).map((key) => ({ text: chiefComplaints[key], value: key }));
    },
  },
  methods: {
    ...mapActions("visitNote", ["clearEncounterNoteFields", "autosave"]),
    ...mapMutations("visitNote", ["setEncounterNotesField"]),
    onChange(value, fieldName) {
      this.setEncounterNotesField({ value, fieldName });
      this.autosave();
    },
  },
};
</script>
